(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-logo-weights"] && !Shopify.designMode) return;
  try {
    
(() => {
 const initialize = root => {
 if (!root || root.dataset.ready) return;
 root.dataset.ready = 'true';
 const finishes = JSON.parse(root.querySelector('[data-kw-finishes]').textContent);
 root.querySelectorAll('[data-finish]').forEach(button => button.addEventListener('click', () => {
  const finish = finishes[Number(button.dataset.finish)];
  const video = root.querySelector('#kw-finish-video');
  root.querySelectorAll('[data-finish]').forEach(b => b.setAttribute('aria-pressed', String(b === button)));
  root.querySelector('#kw-finish-name').textContent = finish.name;
  root.querySelector('#kw-finish-description').textContent = finish.description;
  video.pause();
  video.poster = finish.poster;
  video.setAttribute('aria-label', finish.ariaLabel);
  video.querySelector('source').src = finish.url;
  video.load();
 }));
 root.querySelectorAll('[data-interest]').forEach(link => link.addEventListener('click', () => {
  const input = [...root.querySelectorAll('[data-interest-input]')].find(el => el.dataset.interestInput === link.dataset.interest);
  if (input) input.checked = true;
  if (link.hasAttribute('data-finish-inquiry')) {
   const selected = root.querySelector('[data-finish][aria-pressed="true"]');
   const field = root.querySelector('[data-selected-finish]');
   field.value = finishes[Number(selected.dataset.finish)].name;
   field.disabled = false;
   root.querySelector('[data-selected-finish-wrap]').hidden = false;
  }
 }));
 };
 initialize(document.getElementById('kw-page'));
 document.addEventListener('shopify:section:load', event => initialize(event.target.querySelector('#kw-page')));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kensui-contact"] && !Shopify.designMode) return;
  try {
    
  function initializeKensuiContact(root) {
    if (!root || root.hasAttribute('data-enhanced')) return;
    root.setAttribute('data-enhanced', '');
    const topic = root.querySelector('[data-kct-topic-select]');
    const hint = root.querySelector('[data-kct-hint]');
    const topics = { 'Order or delivery':'order', 'Product advice':'product', 'Returns or exchanges':'returns', 'Wholesale or business':'business' };
    function updateHint() {
      if (topic && hint) hint.textContent = hint.dataset[topics[topic.value] || 'general'];
    }
    if (topic) {
      topic.addEventListener('change', updateHint);
      updateHint();
      root.querySelectorAll('[data-kct-topic]').forEach(link => link.addEventListener('click', () => {
        topic.value = link.dataset.kctTopic;
        updateHint();
        requestAnimationFrame(() => topic.focus({preventScroll:true}));
      }));
    }
    const status = root.querySelector('[data-kct-status]');
    if (status) status.focus();
  }
  document.querySelectorAll('[data-kct]').forEach(initializeKensuiContact);
  document.addEventListener('shopify:section:load', event => initializeKensuiContact(event.target.querySelector('[data-kct]')));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kensui-performance-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const observe = (root) => {
      root.querySelectorAll('[data-kph-motion] .kph__press').forEach((press) => {
        if (press.dataset.revealBound) return;
        press.dataset.revealBound = 'true';
        if (!('IntersectionObserver' in window)) return;
        const observer = new IntersectionObserver((entries) => {
          if (entries.some((entry) => entry.isIntersecting)) {
            press.classList.add('is-revealed');
            observer.disconnect();
          }
        }, { threshold: .25 });
        observer.observe(press);
      });
    };
    observe(document);
    document.addEventListener('shopify:section:load', (event) => observe(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kensui-shop-all"] && !Shopify.designMode) return;
  try {
    
  function initializeKensuiCatalog(root) {
    if (!root || root.hasAttribute('data-enhanced')) return;
    const form = root.querySelector('[data-ksa-controls]');
    const sort = root.querySelector('[data-ksa-sort]');
    if (form && sort) sort.addEventListener('change', () => form.requestSubmit());
    root.querySelectorAll('.ksa-quick').forEach(link => {
      const destination = new URL(link.href);
      const current = new URL(window.location.href);
      current.searchParams.set('sort_by', destination.searchParams.get('sort_by'));
      current.searchParams.delete('page');
      current.hash = 'ksa-catalog';
      link.href = current.toString();
    });
    root.setAttribute('data-enhanced', '');
    root.querySelectorAll('.ksa-filter').forEach(details => {
      details.addEventListener('keydown', event => {
        if (event.key === 'Escape') {
          details.open = false;
          details.querySelector('summary').focus();
        }
      });
    });
  }
  document.querySelectorAll('[data-ksa]').forEach(initializeKensuiCatalog);
  document.addEventListener('shopify:section:load', event => initializeKensuiCatalog(event.target.querySelector('[data-ksa]')));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kensui-trusted-athletes"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('kensui-athlete-gallery')) {
    customElements.define('kensui-athlete-gallery', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.kta__track');
        this.buttons = this.querySelectorAll('.kta__arrow');
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.buttons.forEach(button => button.addEventListener('click', () => this.move(Number(button.dataset.direction)), options));
        this.track.addEventListener('scroll', () => this.update(), { ...options, passive: true });
        this.track.addEventListener('keydown', event => {
          if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          if (event.key === 'Home' || event.key === 'End') this.track.scrollTo({ left: event.key === 'Home' ? 0 : this.track.scrollWidth, behavior: this.behavior() });
          else this.move(event.key === 'ArrowLeft' ? -1 : 1);
        }, options);
        this.addEventListener('shopify:block:select', event => {
          const card = event.target.closest('.kta__card');
          if (card) this.track.scrollTo({ left: card.offsetLeft - this.track.firstElementChild.offsetLeft, behavior: 'auto' });
        }, options);
        this.observer = new ResizeObserver(() => this.update());
        this.observer.observe(this.track);
        this.update();
      }
      disconnectedCallback() { this.abort?.abort(); this.observer?.disconnect(); }
      behavior() { return matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'; }
      move(direction) {
        const card = this.track.firstElementChild;
        if (!card) return;
        const step = card.getBoundingClientRect().width + parseFloat(getComputedStyle(this.track).gap);
        this.track.scrollBy({ left: direction * step, behavior: this.behavior() });
      }
      update() {
        const max = this.track.scrollWidth - this.track.clientWidth;
        this.buttons[0].disabled = this.track.scrollLeft <= 2;
        this.buttons[1].disabled = this.track.scrollLeft >= max - 2;
        const fraction = Math.min(1, this.track.clientWidth / this.track.scrollWidth);
        const progress = max > 0 ? Math.max(0, Math.min(1, this.track.scrollLeft / max)) : 0;
        this.style.setProperty('--kta-progress-width', `${fraction * 100}%`);
        this.style.setProperty('--kta-progress-offset', `${progress * (1 - fraction) / fraction * 100}%`);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kensui-woody-product"]) return;
  try {
    
  function initWoody(root) {
    if (!root || root.dataset.woodyReady) return;
    root.dataset.woodyReady = 'true';
    const slides = [...root.querySelectorAll('[data-woody-slide]')];
    const thumbs = [...root.querySelectorAll('[data-woody-thumb]')];
    const stage = root.querySelector('[data-woody-stage]');
    const rail = root.querySelector('[data-woody-thumbs]');
    const counter = root.querySelector('[data-woody-counter]');
    let active = Math.max(0, slides.findIndex(slide => !slide.hidden));
    function showImage(index) {
      active = (index + slides.length) % slides.length;
      slides.forEach((slide, i) => { slide.hidden = i !== active; });
      thumbs.forEach((thumb, i) => thumb.setAttribute('aria-pressed', String(i === active)));
      if (counter) counter.textContent = `${active + 1} / ${slides.length}`;
      const thumb = thumbs[active];
      if (thumb && rail) {
        const left = thumb.offsetLeft - rail.offsetLeft;
        if (left < rail.scrollLeft || left + thumb.offsetWidth > rail.scrollLeft + rail.clientWidth) rail.scrollTo({left:left - rail.clientWidth / 2 + thumb.offsetWidth / 2,behavior:'auto'});
      }
    }
    thumbs.forEach((thumb, index) => thumb.addEventListener('click', () => showImage(index)));
    root.querySelectorAll('[data-woody-step]').forEach(button => button.addEventListener('click', () => showImage(active + Number(button.dataset.woodyStep))));
    let touchStart = null;
    stage.addEventListener('touchstart', event => { touchStart = {x:event.touches[0].clientX,y:event.touches[0].clientY}; }, {passive:true});
    stage.addEventListener('touchend', event => {
      if (!touchStart) return;
      const dx = event.changedTouches[0].clientX - touchStart.x;
      const dy = event.changedTouches[0].clientY - touchStart.y;
      if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.5) showImage(active + (dx < 0 ? 1 : -1));
      touchStart = null;
    }, {passive:true});
    const select = root.querySelector('[data-woody-select]');
    const options = [...root.querySelectorAll('[data-woody-variant]')];
    const add = root.querySelector('[data-woody-add]');
    const stock = root.querySelector('[data-woody-stock]');
    function updateVariant(id, updateUrl) {
      const variant = [...select.options].find(option => option.value === String(id));
      if (!variant) return;
      select.value = variant.value;
      const available = variant.dataset.available === 'true';
      window.KensuiStockDelivery?.update(root, variant.value);
      root.dataset.woodyAvailable = String(available);
      options.forEach(button => { const chosen = button.dataset.woodyVariant === variant.value; button.classList.toggle('on', chosen); button.setAttribute('aria-pressed', String(chosen)); });
      root.querySelector('[data-woody-price]').innerHTML = variant.dataset.price;
      const compare = root.querySelector('[data-woody-compare]');
      compare.innerHTML = variant.dataset.compare || '';
      compare.hidden = !variant.dataset.compare;
      add.disabled = !available;
      add.textContent = available ? add.dataset.addLabel + ' ↗' : add.dataset.soldLabel;
      stock.textContent = available ? stock.dataset.availableLabel : stock.dataset.unavailableLabel;
      if (updateUrl && variant.dataset.imageId) { const imageIndex = slides.findIndex(slide => slide.dataset.woodyImageId === variant.dataset.imageId); if (imageIndex >= 0) showImage(imageIndex); }
      if (updateUrl) { const url = new URL(window.location.href); url.searchParams.set('variant',variant.value); window.history.replaceState({},'',url); }
    }
    options.forEach(button => button.addEventListener('click', () => { updateVariant(button.dataset.woodyVariant, true); select.dispatchEvent(new Event('change',{bubbles:true})); }));
    select.addEventListener('change', () => updateVariant(select.value, true));
    showImage(active);
    updateVariant(select.value, false);
  }
  document.querySelectorAll('[data-woody-section]').forEach(initWoody);
  document.addEventListener('shopify:section:load', event => initWoody(event.target.querySelector('[data-woody-section]')));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ks-rubber-strap"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ks-rubber-strap')) {
    customElements.define('ks-rubber-strap', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.controller = new AbortController();
        const on = (element, type, handler, options = {}) => element?.addEventListener(type, handler, { signal: this.controller.signal, ...options });
        this.form = this.querySelector('form');
        this.add = this.querySelector('[data-krs-add]');
        this.choices = [...this.form.querySelectorAll('[name="quantity"]')];
        this.packs = this.querySelector('[data-krs-packs]');
        this.status = this.querySelector('[data-krs-status]');
        this.track = this.querySelector('[data-krs-track]');
        this.slides = [...this.querySelectorAll('[data-krs-slide]')];
        this.thumbs = [...this.querySelectorAll('[data-krs-thumb]')];
        this.zoom = this.querySelector('[data-krs-zoom]');
        this.index = 0;
        this.querySelector('[data-krs-thumbnails]').hidden = false;
        this.querySelectorAll('[data-krs-step]').forEach(button => { button.hidden = this.slides.length < 2; });
        const syncGallery = () => {
          if (!this.track.clientWidth) return;
          this.index = Math.round(this.track.scrollLeft / this.track.clientWidth);
          this.thumbs.forEach((thumb, index) => thumb.setAttribute('aria-pressed', String(index === this.index)));
          this.querySelector('[data-krs-count]').textContent = String(this.index + 1);
          this.querySelector('[data-krs-step="-1"]').disabled = this.index === 0;
          this.querySelector('[data-krs-step="1"]').disabled = this.index >= this.slides.length - 1;
        };
        this.goTo = (index, behavior) => this.track.scrollTo({left: Math.max(0, Math.min(index, this.slides.length - 1)) * this.track.clientWidth, behavior: behavior || (matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth')});
        on(this.track, 'scroll', () => { cancelAnimationFrame(this.frame); this.frame = requestAnimationFrame(syncGallery); }, {passive:true});
        on(this.track, 'keydown', event => {
          if (!['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
          event.preventDefault();
          this.goTo(event.key === 'Home' ? 0 : event.key === 'End' ? this.slides.length - 1 : this.index + (event.key === 'ArrowLeft' ? -1 : 1));
        });
        on(this, 'click', event => {
          const thumb = event.target.closest('[data-krs-thumb]');
          const arrow = event.target.closest('[data-krs-step]');
          const slide = event.target.closest('[data-krs-slide]');
          if (thumb) this.goTo(Number(thumb.dataset.krsThumb));
          if (arrow) this.goTo(this.index + Number(arrow.dataset.krsStep));
          if (slide && this.zoom.showModal) {
            event.preventDefault();
            const image = this.querySelector('[data-krs-zoom-image]');
            image.src = slide.href;
            image.alt = slide.dataset.alt;
            this.zoom.showModal();
          }
        });
        on(this.querySelector('[data-krs-zoom-close]'), 'click', () => this.zoom.close());
        on(this.zoom, 'click', event => { if (event.target === this.zoom) this.zoom.close(); });
        on(this.form, 'change', () => { this.syncChoice(); this.status.hidden = true; this.querySelector('[data-krs-cart]').hidden = true; });
        on(this.form, 'submit', event => this.submit(event), {capture:true});
        this.resize = new ResizeObserver(() => { this.goTo(this.index, 'instant'); syncGallery(); });
        this.resize.observe(this.track);
        this.stickyObserver = new IntersectionObserver(entries => { this.querySelector('[data-krs-sticky]').hidden = entries[0].boundingClientRect.bottom > 0; });
        this.stickyObserver.observe(this.form);
        this.syncChoice();
        syncGallery();
      }
      syncChoice() {
        const choice = this.choices.find(input => input.checked);
        this.add.disabled = this.pending || choice.dataset.available !== 'true';
        this.add.textContent = this.pending ? this.dataset.addingLabel : choice.dataset.available === 'true' ? this.dataset.addLabel : this.dataset.soldLabel;
        this.querySelector('[data-krs-availability]').textContent = choice.dataset.available === 'true' ? this.dataset.availableLabel : this.dataset.soldLabel;
        this.querySelector('[data-krs-selected-name]').textContent = choice.dataset.name;
        this.querySelector('[data-krs-selected-price]').textContent = choice.dataset.price;
      }
      async submit(event) {
        if (event.submitter?.closest('.ks-express-checkout')) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        const choice = this.choices.find(input => input.checked);
        if (this.pending || choice.dataset.available !== 'true') return;
        const variant = this.form.querySelector('[name="id"]').value;
        const quantity = Number(choice.value);
        this.pending = true;
        this.packs.disabled = true;
        this.form.setAttribute('aria-busy', 'true');
        this.status.hidden = true;
        this.querySelector('[data-krs-cart]').hidden = true;
        this.syncChoice();
        try {
          const response = await fetch(this.dataset.addUrl, {method:'POST', credentials:'same-origin', headers:{'Content-Type':'application/json','Accept':'application/json'}, body:JSON.stringify({items:[{id:variant,quantity}]})});
          const data = await response.json();
          if (!response.ok) throw new Error(typeof data.description === 'string' ? data.description : this.dataset.errorLabel);
          this.status.dataset.error = 'false';
          this.status.textContent = this.dataset.addedLabel;
          this.querySelector('[data-krs-cart]').hidden = false;
          document.dispatchEvent(new CustomEvent('cart:open'));
        } catch (error) {
          this.status.dataset.error = 'true';
          this.status.textContent = error instanceof TypeError ? this.dataset.errorLabel : error.message;
        } finally {
          this.pending = false;
          this.packs.disabled = false;
          this.form.removeAttribute('aria-busy');
          this.status.hidden = false;
          this.syncChoice();
        }
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.resize?.disconnect();
        this.stickyObserver?.disconnect();
        cancelAnimationFrame(this.frame);
        this.ready = false;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ks-swivel-shackles"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ks-swivel-shackles')) {
    customElements.define('ks-swivel-shackles', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.controller = new AbortController();
        const on = (element, event, callback, options = {}) => element.addEventListener(event, callback, {...options, signal: this.controller.signal});
        this.track = this.querySelector('[data-kss-track]');
        this.thumbs = Array.from(this.querySelectorAll('[data-kss-index]'));
        this.querySelector('[data-kss-thumbs]').hidden = false;
        this.thumbs.forEach(button => on(button, 'click', () => this.track.scrollTo({left: Number(button.dataset.kssIndex) * this.track.clientWidth, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'})));
        on(this.track, 'scroll', () => {
          cancelAnimationFrame(this.frame);
          this.frame = requestAnimationFrame(() => {
            const index = Math.round(this.track.scrollLeft / this.track.clientWidth);
            this.thumbs.forEach((button, i) => button.setAttribute('aria-current', String(i === index)));
          });
        }, {passive:true});
        this.form = this.querySelector('.kss__form');
        this.quantity = this.form.querySelector('[name="quantity"]');
        this.add = this.form.querySelector('[name="add"]');
        this.label = this.add.querySelector('[data-kss-add-label]');
        this.idleLabel = this.label.textContent;
        this.status = this.querySelector('[data-kss-status]');
        this.steps = Array.from(this.querySelectorAll('[data-kss-step]'));
        this.steps.forEach(button => {
          button.hidden = false;
          on(button, 'click', () => {
            this.quantity.value = String(Math.max(1, Math.floor(Number(this.quantity.value) || 1) + Number(button.dataset.kssStep)));
            this.syncQuantity();
          });
        });
        on(this.quantity, 'change', () => {
          this.quantity.value = String(Math.max(1, Math.floor(Number(this.quantity.value) || 1)));
          this.syncQuantity();
        });
        on(this.form, 'submit', event => this.submit(event), {capture:true});
        this.dataset.ready = 'true';
        this.syncQuantity();
      }
      syncQuantity() {
        this.steps.forEach(button => button.disabled = this.quantity.disabled || (Number(button.dataset.kssStep) < 0 && Number(this.quantity.value) <= 1));
      }
      async submit(event) {
        if (event.submitter?.closest('.ks-express-checkout')) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        if (this.pending || this.add.disabled || !this.form.reportValidity()) return;
        this.pending = true;
        const quantity = Number(this.quantity.value);
        this.add.disabled = true;
        this.quantity.disabled = true;
        this.syncQuantity();
        this.label.textContent = this.dataset.adding;
        this.form.setAttribute('aria-busy', 'true');
        this.status.hidden = true;
        this.querySelector('[data-kss-cart]').hidden = true;
        try {
          const response = await fetch(this.dataset.addUrl, {method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:this.form.querySelector('[name="id"]').value,quantity}]})});
          const data = await response.json();
          if (!response.ok) throw new Error(typeof data.description === 'string' ? data.description : this.dataset.error);
          this.status.dataset.error = 'false';
          this.status.textContent = this.dataset.added;
          this.querySelector('[data-kss-cart]').hidden = false;
          document.dispatchEvent(new CustomEvent('cart:open'));
        } catch (error) {
          this.status.dataset.error = 'true';
          this.status.textContent = error instanceof TypeError ? this.dataset.error : error.message;
        } finally {
          this.pending = false;
          this.add.disabled = false;
          this.quantity.disabled = false;
          this.syncQuantity();
          this.label.textContent = this.idleLabel;
          this.form.removeAttribute('aria-busy');
          this.status.hidden = false;
        }
      }
      disconnectedCallback() {
        this.controller?.abort();
        cancelAnimationFrame(this.frame);
        this.ready = false;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
